import TextField from "@mui/material/TextField";

import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import React, { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { addCategory } from "../../feature/category/categorySlice";
import { Alert, Snackbar } from "@mui/material";

const CategoryForm = () => {
  // adding category state
  const [name, setName] = useState("");
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [message, setMessage] = useState("");
  // const accessTokenState = useSelector((state) => state.auth.accessToken);

  const {
    isLoading,
    isSuccess,
    isError,
    message: responseMessage,
  } = useSelector((state) => state.categories);

  // const [message, setMessage] = useState({
  //   isSuccess: "false",
  //   isError: "false",
  // });
  console.log("isCatSuccess", isSuccess);

  const dispatch = useDispatch();

  const accessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NywiZW1haWwiOiJuaWtrdUBnbWFpbC5jb20iLCJyb2xlcyI6ImFkbWluIiwiaWF0IjoxNjg4NDQ5MzQ1LCJleHAiOjE2ODg0NzgxNDV9.82MqWJ6wwuY3Pi2QlWcpP0KtDQmnOh4ejrOqS9H50Rk";

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(addCategory({ name, accessToken }));
    if (isSuccess && responseMessage !== "") {
      setIsSnackbarOpen(true);
      setMessage(responseMessage);
      setName("");
    } else {
      console.log("error response", message);
    }
  };

  if (isLoading) return <h2>Loading...</h2>;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Stack direction='column' spacing={2}>
          <TextField
            fullWidth
            label='Category Name'
            id='category_name'
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            required
          />
          <Stack direction='row' spacing={2}>
            <Button disabled={!name} variant='contained' type='submit'>
              SAVE
            </Button>
            <Button variant='contained' color='error'>
              CANCEL
            </Button>
          </Stack>
        </Stack>
      </form>
      {/* <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          This is a success message!
        </Alert>
      </Snackbar> */}
      <Snackbar open={isSnackbarOpen} autoHideDuration={6000}>
        Success
      </Snackbar>
    </>
  );
};

export default CategoryForm;
